import { Box } from '@mui/material'
import InvestigationNav from './InvestigationNav'
import InvestigationRoutes from './InvestigationRoutes'

const InvestigationLayout = () => {
  return (
    <>
      <InvestigationNav />
      <Box sx={{ px: 3 }}>
        <InvestigationRoutes />
      </Box>
    </>
  )
}

export default InvestigationLayout
